
export const facebookLink = ' https://www.facebook.com/profile.php?id=100091617412565&mibextid=ZbWKwL'

export const instagramLink = ' https://instagram.com/ba_zaar_cheap?igshid=YmMyMTA2M2Y='

export const twitterLink = 'https://www.twitter.com/@bazaar_cheap'

export const tiktokLink  = 'https://www.tiktok.com/@bazaar_cheap'